"use strict";

require("core-js/modules/es.object.define-property.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.keysToSnakeCase = exports["default"] = void 0;
var _inflected = require("inflected");
var _transformKeys = _interopRequireDefault(require("./transformKeys"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Converts all keys in an object to snake_case format recursively
 * @param {Object} object - The object whose keys should be converted
 * @returns New object with snake_case keys
 */
var keysToSnakeCase = exports.keysToSnakeCase = function keysToSnakeCase(object) {
  return (0, _transformKeys["default"])(object, _inflected.underscore);
};
var _default = exports["default"] = keysToSnakeCase;